// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgFollowerUnique24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.13636 4.25C11.3581 4.25 13.1591 6.05104 13.1591 8.27273C13.1591 10.4944 11.3581 12.2955 9.13636 12.2955C6.91467 12.2955 5.11364 10.4944 5.11364 8.27273C5.11364 6.05104 6.91467 4.25 9.13636 4.25ZM9.13636 5.75C7.7431 5.75 6.61364 6.87946 6.61364 8.27273C6.61364 9.66599 7.7431 10.7955 9.13636 10.7955C10.5296 10.7955 11.6591 9.66599 11.6591 8.27273C11.6591 6.87946 10.5296 5.75 9.13636 5.75ZM12 13.25C14.2217 13.25 16.0227 15.051 16.0227 17.2727V18.9091C16.0227 19.3233 15.6869 19.6591 15.2727 19.6591H3C2.58579 19.6591 2.25 19.3233 2.25 18.9091V17.2727C2.25 15.051 4.05104 13.25 6.27273 13.25H12ZM12.1659 14.7554L12 14.75H6.27273C4.87946 14.75 3.75 15.8795 3.75 17.2727V18.159H14.522L14.5227 17.2727C14.5227 15.9352 13.4818 14.8408 12.1659 14.7554Z"
					fill="#2E2F32"
				/>
				<path
					d="M22.0623 11.4312C22.3552 11.7241 22.3552 12.199 22.0623 12.4919L18.5911 15.9631C18.2982 16.256 17.8233 16.256 17.5304 15.9631C17.2375 15.6702 17.2375 15.1954 17.5304 14.9025L21.0017 11.4312C21.2945 11.1383 21.7694 11.1383 22.0623 11.4312Z"
					fill="#7F86F3"
				/>
				<path
					d="M21.7592 10.9961C22.1734 10.9961 22.5092 11.3319 22.5092 11.7461C22.5092 12.1603 22.1734 12.4961 21.7592 12.4961H14.8501C14.4359 12.4961 14.1001 12.1603 14.1001 11.7461C14.1001 11.3319 14.4359 10.9961 14.8501 10.9961H21.7592Z"
					fill="#7F86F3"
				/>
				<path
					d="M17.5303 7.53022C17.8232 7.23732 18.2981 7.23732 18.591 7.53022L22.0622 11.0015C22.3551 11.2944 22.3551 11.7692 22.0622 12.0621C21.7693 12.355 21.2945 12.355 21.0016 12.0621L17.5303 8.59088C17.2374 8.29798 17.2374 7.82311 17.5303 7.53022Z"
					fill="#7F86F3"
				/>
			</Svg>
		);
	}
);
SvgFollowerUnique24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgFollowerUnique24;
